import "./LayerBox.scss";

function LayerBox (props) {

    return (
        <div className={"layerBox " + props.active}/>
    )
}

export default LayerBox;